import type { TourStep } from '../types';

export const eoCheckSteps: TourStep[] = [
  {
    target: '[data-tour="settings-tabs"]',
    title: 'Navigate to E&O Rules',
    content:
      'Click the "E&O Rules" tab in the settings bar. This is where you manage custom validation rules that protect you from Errors & Omissions.',
    placement: 'bottom',
    route: '/settings',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: "I'm on the tab",
  },
  {
    target: '[data-tour="eo-rules-library"]',
    title: 'Start with the Starter Library',
    content:
      'Click the "Starter Library" tab. It has pre-built rules for USPAP compliance, NJ-specific requirements, and common quality checks — install them with one click instead of writing from scratch.',
    placement: 'bottom',
    route: '/settings',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I see the library',
  },
  {
    target: '[data-tour="eo-rules-new"]',
    title: 'Create a Custom Rule',
    content:
      'Need something specific? Click "New Rule" to build your own. You can require fields, set min/max values, compare fields, or create if-then conditions — all without code.',
    placement: 'bottom',
    route: '/settings',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: '[data-tour="eo-rules-list"]',
    title: 'Manage Your Active Rules',
    content:
      'All your installed and custom rules appear here. Toggle any rule on/off with the switch, or use the menu to edit, duplicate, or delete. Disabled rules are skipped during export checks.',
    placement: 'bottom',
    route: '/settings',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="eo-rules-card"]',
    title: 'How It All Works Together',
    content:
      'When you export a report, Ashlar runs your custom rules alongside built-in system checks. Errors block the export, warnings flag issues for review, and info items are advisory. Build a rule set once and every report benefits.',
    placement: 'top',
  },
];
